<script>
export default {
	props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
	},
  data() {
    return {
      
    }
  }
}
</script>

<template>
  <div :class="$style.baseBlock">
    <div class="baseBlock__box">
      <h4 v-if="title" class="baseBlock__title" v-html="title"></h4>
      <p v-if="content" class="color-text- mt-3 baseBlock__content" v-html="content"></p>
    </div>
  </div>
</template>

<style lang="scss" module>
.baseBlock {
    width: 1028px;
    max-width: 100%;
    // margin-top: 50px;
    padding-left: 100px;
    padding-right: 100px;
    position: relative;
    text-align: center;
    margin: 60px auto 0;
    @include max-lg {
      padding-left: 10px;
      padding-right: 10px;
      margin: 40px auto 0;
    }
    &:before {
      content: url('@assets/images/home/section6-paw-left.svg');
      position: absolute;
      left: 50px;
      bottom: 40px;
      z-index: 2;
      @include max-lg {
        display: none;
      }
    }
    &:after {
      content: url('@assets/images/home/section6-paw-right.svg');;
      position: absolute;
      right: 40px;
      bottom: -80px;
      @include max-lg {
        display: none;
      }
    }
  :global {
    .baseBlock {
      &__box {
        background: #FFFFFF;
        box-shadow: 0px 3px 24px rgba(84, 86, 98, 0.1);
        border-radius: 10px;
        margin-top: 30px;
        margin-bottom: 80px;
        padding: 40px 100px;
        @include max-md {
          padding: 24px 36px;
          margin-bottom: 0;
          font-size: 14px;
        }
      }
      &__title {
        line-height: 1.5;
        font-size: 1.25rem;
        @include max-md {
          font-size: 1.125rem;
        }
      }
      &__content {
        color: $color-text-2;
      }
    }
  }
  &:global {
    &.isStylePrimary {
      .baseBlock {
        &__title {
          font-size: 1.5rem;
          color: $color-primary;
          @include max-md {
            font-size: 1.25rem;
          }
        }
      }
    }
  }
}
</style>